<template>
    <div class="introduce">
        <!-- 纸搬客 -->
        <div class="common-border value" style="margin-top: 0.15rem;">
            <h3>纸搬客<br>让每一张废纸更有价值</h3>
            <img src="../assets/img/introduce/1.png" alt="" class="animated fadeInUp">
        </div>
        <!-- 一键扫码 -->
        <div class="common-spe sweepCode">
            <div class="sweepCode-left">
                <ul>
                    <li>
                        <h3>一键扫码</h3>
                        <p>立即碎纸,&nbsp;智能无需多言</p>
                    </li>
                    <li>
                        <h3>优选商城</h3>
                        <p>百种商品,&nbsp;上线待命</p>
                        <p>记住不要一分钱</p>
                    </li>
                    <li>
                        <h3>个人中心</h3>
                        <p>环保根据地,提现,记录</p>
                        <p>惊喜,&nbsp;不止于此</p>
                    </li>
                </ul>
            </div>
            <div class="sweepCode-right">
                <img src="../assets/img/introduce/2.png" alt="">
            </div>
        </div>
        <!-- 维生素重要,蛋白质更重要 -->
        <div class="common-spe important">
            <div class="important-left">
                <img src="../assets/img/introduce/3.png" alt="">
            </div>
            <div class="important-right">
                <ul>
                    <li style="margin-top: 0.13rem;">
                        <h3>维生素重要,&nbsp;&nbsp;蛋白质更重要</h3>
                        <p>投递废纸，每日领取鸡蛋</p>
                        <p>你家的鸡蛋，纸搬客买单</p>
                    </li>
                    <li>
                        <h3>试试种棵果树 </h3>
                        <p>随着每一次投递，浇水让</p>
                        <p>小树成长，果树结果，</p>
                        <p>水果到家</p>
                    </li>
                    <li>
                        <h3>提现？兑换？远不止于此</h3>
                        <p>试试生活缴费</p>
                        <p>手机费也能搞得定</p>
                    </li>
                </ul>
            </div>
        </div>
        <!-- 排行榜 -->
        <div class="common-border rankList">
            <div class="rankList-left">
                <ul>
                    <li style="margin-top: 0.17rem;">
                        <h3>排行榜</h3>
                        <p>站榜首冲,&nbsp;做社区的"环保王"</p>
                        <p>更有现金奖励</p>
                    </li>
                    <li>
                        <h3>环保数据</h3>
                        <p>记录每一次投递</p>
                        <p>小举动大贡献</p>
                    </li>
                    <li>
                        <h3>会员中心</h3>
                        <p>越碎越有,等级提升,收益</p>
                        <p>上涨,&nbsp;环保如游戏般有趣</p>
                    </li>
                </ul>
            </div>
            <div class="rankList-right">
                <img src="../assets/img/introduce/4.png" alt="">
            </div>
        </div>
        <!-- 纸搬客环保同心,以纸易金 -->
        <div class="common-border environmental">
            <div class="environmental-left">
                <h2>纸搬客<br>环保同心,以纸易金</h2>
            </div>
            <div class="environmental-right">
                <img src="../assets/img/introduce/5.png" alt="">
            </div>
        </div>
        <footer_s></footer_s>
    </div>
</template>
<script>
    import $ from 'jquery'
    import footer_s from '../views/common/footer'
    export default {
        name: 'introduce',
        components: {
            footer_s,
        },
        mounted(){
            $(function(){
                $('.value h3').animate({
                    opacity: 1
                }, 2000)
                $(window).scroll(function(){
                    var scrollT=$(window).scrollTop(); //滚动的高度
                    var ViewHeight = $(window).height(); //视口的高度
                    var sweepCodeHeight = $('.sweepCode').offset().top; //元素的高度
                    var importantHeight = $('.important').offset().top; //元素的高度
                    var rankListHeight = $('.rankList').offset().top; //元素的高度
                    var environmentalHeight = $('.environmental').offset().top; //元素的高度
                    if (scrollT + ViewHeight >= sweepCodeHeight) {
                        $('.sweepCode-right img').addClass('animated fadeInRightBig')
                        $('.sweepCode-left h3,.sweepCode-left p').addClass('animated fadeInLeftBig').animate({
                            opacity: 1
                        }, 3000)
                    }
                    if (scrollT + ViewHeight >= importantHeight) {
                        $('.important-left img').addClass('animated zoomInLeft')
                        $('.important-right h3,.just-right p').addClass('animated zoomInRight').animate({
                            opacity: 1
                        }, 3000)
                    }
                    if (scrollT + ViewHeight >= rankListHeight) {
                        $('.rankList-right img').addClass('animated fadeInRightBig')
                        $('.rankList-left h3,.rankList-left p').addClass('animated fadeInLeftBig').animate({
                            opacity: 1
                        }, 3000)
                    }
                    if (scrollT + ViewHeight >= environmentalHeight) {
                        $('.environmental h2').animate({
                            opacity: 1
                        }, 3000)
                        $('.environmental img').addClass('animated fadeInUp');
                    } 
                })
            })
        },
        beforeDestroy(){
            $(window).off('scroll')
        }
    }
</script>
<style scoped>
    .introduce {
        width: 100%;
        height: 100%;
        background-color: #F5F5F7;

    }

    .common-spe {
        border-left: 0.08rem solid #F5F5F7;
        border-right: 0.08rem solid #F5F5F7;
        border-bottom: 0.07rem solid #F5F5F7;
    }

    .common-border {
        border-left: 0.08rem solid #F5F5F7;
        border-right: 0.08rem solid #F5F5F7;
        border-bottom: 0.12rem solid #F5F5F7;
    }

    .value {
        height: 1.94rem;
        position: relative;
        padding: 0.15rem 0 0 0.63rem;
        background-color: #fff;
    }

    .value h3 {
        font-size: 0.16rem;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: rgba(55, 55, 55, 1);
        line-height: 0.21rem;
        opacity: 0.3;
    }

    .value img {
        width: 1.24rem;
        height: 1.22rem;
        position: absolute;
        top: 0.59rem;
        left: 50%;
        margin-left: -0.62rem;
    }

    .sweepCode,
    .important,
    .rankList {
        min-height: 1.31rem;
        overflow: hidden;
        margin: 0 auto;
        background-color: #F5F5F7;
        margin-left: 0.58rem;
    }
    .sweepCode-left,
    .important-right,
    .rankList-left {
        width: 1.19rem;
        height: 1.31rem;
        float: left;
        background-color: #fff;
    }

    .sweepCode-left ul li{
        margin-top: 0.13rem;
    }
    .important-right ul li,
    .rankList-left ul li {
        margin-top: 0.07rem;
    }

    .sweepCode-left h3,
    .important-right h3,
    .rankList-left h3 {
        font-size: 0.06rem;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: #676767;
        line-height: 0.1rem;
        text-align: center;
        opacity: 0.3;
    }

    .sweepCode-left p,
    .important-right p,
    .rankList-left p {
        font-size: 0.04rem;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: #676767;
        line-height: 0.06rem;
        text-align: center;
        margin-top: 0.03rem;
        /* opacity: 0.3; */
    }

    .sweepCode-left,
    .important-left,
    .rankList-left {
        margin-right: 0.05rem;
    }

    .sweepCode-right,
    .important-left,
    .rankList-right {
        width: 1.19rem;
        height: 1.31rem;
        float: left;
        background-color: #fff;
    }

    .sweepCode-right img,
    .important-left img,
    .rankList-right img {
        width: 0.88rem;
        height: 0.8rem;
        margin: 0.19rem 0 0 0.16rem;
    }

    .environmental {
        height: 1.94rem;
        background-color: #fff;
    }

    .environmental-left {
        width: 60%;
        float: left;
    }

    .environmental-left h2 {
        font-size: 0.14rem;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: #373737;
        line-height: 0.21rem;
        /* margin-bottom: 0.04rem; */
        letter-spacing: 0.01rem;
        margin: 0.55rem 0 0 0.62rem;
        opacity: 0.3;
    }

    .environmental-right {
        width: 40%;
        height: 1.82rem;
        float: left;
        position: relative;
    }

    .environmental-right img {
        width: 1.11rem;
        height: 1.1rem;
        position: absolute;
        bottom: 0;
        right: 0.45rem;
    }
</style>


// WEBPACK FOOTER //
// src/views/introduce.vue